/**
 * A situação de um arquivo na conferência mais recente da custódia (E134.F2, GUS-159, ADR-0090):
 * o texto da linha e o selo. Sem conferência, a linha diz que o arquivo ainda não foi conferido e
 * não há selo: a tela não afirma preservação que ninguém conferiu.
 */
import { Badge } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { SituacaoConferidaData } from '@/lib/abertura_do_caso';
import { formatarDataHora } from '@/lib/trilha_format';

const t = ptBR.abertura.custodia;

/** O que a linha diz da conferência; sem conferência, que ainda não foi conferido. */
export function textoDaSituacao(conferencia: SituacaoConferidaData | null | undefined): string {
  if (conferencia === null || conferencia === undefined) return t.situacao.naoConferido;
  return t.situacao[conferencia.situacao].replace(
    '{data}',
    formatarDataHora(conferencia.conferido_em),
  );
}

/** O selo da situação; `null` quando a conferência ainda não disse nada. */
export function SeloDaSituacao({
  conferencia,
}: {
  conferencia: SituacaoConferidaData | null | undefined;
}): JSX.Element | null {
  if (conferencia === null || conferencia === undefined) return null;
  const variante = {
    confere: 'success',
    diverge: 'danger',
    ausente: 'danger',
    sem_registro: 'warning',
  } as const;
  return (
    <Badge variant={variante[conferencia.situacao]} data-testid="custodia-situacao">
      {t.selo[conferencia.situacao]}
    </Badge>
  );
}
